<script setup lang="ts"></script>
<template>
  <PrimeToast position="bottom-right" class="cursor-pointer">
    <template #container="{ message, closeCallback }">
      <div
        v-tooltip="'Kliknij żeby zamknąć'"
        class="p-4 text-sm"
        @click="closeCallback()"
      >
        <CheckCircle v-if="message.severity === 'success'" />
        <XCircle v-if="message.severity === 'error'" />
        <p class="mb-1 mt-4 font-semibold text-slate-700">
          {{ message.summary }}
        </p>
        <p class="text-slate-600">{{ message.detail }}</p>
      </div>
    </template>
  </PrimeToast>
</template>
